import { APPLICATION_GROUP_BY, Route } from '@/core/entities';
import { createRouteLoaderPageDetails } from '@/core/utils/routes.utils';
import { Main } from '@/core/views';
import { List } from '@/modules/companyHealthDataConfig/pages/list/list';
import { USER_TYPE } from '@/services/users/endpoints/users';
import ICONS from '@/shared/entities/constants/icons';

export enum ROUTE_HEALTH_DATA {
  LIST = 'health-data-list',
}

const Routes: Route[] = [
  {
    path: '/health-data',
    Component: Main,
    id: ROUTE_HEALTH_DATA.LIST,
    meta: {
      groupedBy: APPLICATION_GROUP_BY.BROKER,
      showApplicationMenu: true,
      icon: ICONS.TRENDING_UP,
      nameMenu: 'Dados de saúde',
      permission: {
        type: USER_TYPE.BROKER,
      },
    },
    loader() {
      return createRouteLoaderPageDetails({
        groupedBy: APPLICATION_GROUP_BY.BROKER,
        icon: ICONS.TRENDING_UP,
        name: 'Dados de saúde',
        description: 'Defina quais empresas poderão visualizar os dados de saúde',
        title: 'Dados de saúde',
      });
    },
    children: [
      {
        index: true,
        Component: List,
      },
    ],
  },
];

export default Routes;
